function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "CompanySegmentProspects_svg__13_a",
  x1: "0%",
  x2: "100%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#7793FF"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#1877F2"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "url(#CompanySegmentProspects_svg__13_a)",
  d: "M8 0h34a8 8 0 018 8v34a8 8 0 01-8 8H8a8 8 0 01-8-8V8a8 8 0 018-8z"
}), React.createElement("path", {
  fill: "#CCE4FE",
  d: "M32.933 24a3.606 3.606 0 013.346 2.182c.813.3 1.495.873 1.929 1.619l2.5 4.705h-.066a5.515 5.515 0 01-1.243 5.837 5.607 5.607 0 01-5.855 1.334 5.549 5.549 0 01-3.596-6.331 5.48 5.48 0 01.191-.675 1.825 1.825 0 00-1.64-1.02c-.698 0-1.335.396-1.64 1.02.078.22.142.444.191.672l.049.275a5.579 5.579 0 01.036 1.36 5.553 5.553 0 01-4.108 4.828 5.6 5.6 0 01-5.99-2.134 5.512 5.512 0 01-.08-6.321l1.948-3.532a3.71 3.71 0 011.82-1.586A3.602 3.602 0 0124.062 24c1.467 0 2.787.883 3.338 2.233a2.486 2.486 0 012.22 0A3.605 3.605 0 0132.934 24zm-7.897 9.506c-.541-1.793-2.368-2.887-4.224-2.53-1.856.358-3.135 2.05-2.957 3.912.178 1.862 1.755 3.287 3.646 3.294 2.033.003 3.685-1.625 3.69-3.636 0-.353-.052-.703-.155-1.04zm10.45-2.597a3.691 3.691 0 00-3.525 2.595c-.103.338-.154.69-.152 1.044.005 2.01 1.65 3.635 3.677 3.634a3.665 3.665 0 003.312-2.053 3.606 3.606 0 00-.44-3.848l-.19-.23h-.015a3.667 3.667 0 00-2.667-1.142zM16.75 28l-1.335 2.419.054-.08c-.147.215-.28.436-.401.661h-.484c-.286 0-.524.221-.574.513l-.009.112v.75c0 .259.147.481.357.576a7.303 7.303 0 00.008 3.05L12.725 36A1.72 1.72 0 0111 34.286v-4.572A1.72 1.72 0 0112.725 28h4.024zm15.526-17c.953 0 1.725.775 1.725 1.73v9.57a5.43 5.43 0 00-1.081-.1l-.233.007a5.415 5.415 0 00-3.768 1.802l-.146.169-.261-.007-.262.007a5.418 5.418 0 00-4.187-1.978l-.234.005a5.408 5.408 0 00-4.347 2.523l-.096.16-.044.024A5.513 5.513 0 0018.011 26L12.725 26A1.728 1.728 0 0111 24.27V12.73c0-.955.772-1.73 1.725-1.73h19.55zm-9.829 7h-7.892c-.272 0-.498.221-.545.513l-.009.112v.75c0 .307.196.562.454.615l.1.01h7.892c.272 0 .498-.221.545-.513l.009-.112v-.75c0-.307-.196-.562-.454-.615l-.1-.01zm6.983-4H14.57c-.28 0-.513.221-.562.513l-.009.112v.75c0 .307.202.562.469.615l.102.01H29.43c.28 0 .513-.221.562-.513l.009-.112v-.75c0-.307-.202-.562-.469-.615L29.43 14z"
}));

var SvgCompanySegmentProspects = function SvgCompanySegmentProspects(props) {
  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2);
};

export default SvgCompanySegmentProspects;